import React from "react";

export const CheckIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.15385 14L0 7.63057L1.73615 5.8336L6.15385 10.3949L14.2646 2L16 3.80892L6.15385 14Z" fill="currentColor" />
  </svg>
);
